<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <h1>Bienvenido al sistema</h1>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// Landing page tras el login. A proposito no hace ninguna llamada al servidor:
// es la vista por defecto para todos los roles, y no debe generar carga en el
// backend solo por entrar al CMS. El dashboard de ventas vive en su propia
// pestaña (Dashboard) y solo se calcula cuando el usuario la visita.
export default {};
</script>
